import React, { useEffect } from "react";
import { Search } from "react-bootstrap-table2-toolkit";
// 데이터 리스트
const { SearchBar, ClearSearchButton } = Search;

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const SearchTable = ({ props, size }) => {
  useEffect(() => {
    var field = document.getElementById("search-bar-0");
    if (field) {
      field.id = uuidv4();
    }
  }, []);
  return (
    <div className={`col-12 search-area flex align-items-center justify-center mt-3 mt-xl-0 ${size}`}>
      <i className="ti-search pl-3"></i>
      <SearchBar {...props.searchProps} className="border-search-box" />
      <ClearSearchButton {...props.searchProps} className="clear-btn-2 mr-3" />
    </div>
  );
};

export default SearchTable;
